import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { TypePages } from ".";
import IconButton from "../../../../components/IconButton";
import { InputMobile, LabelMobile, MergeLabelAndInputMobile } from "../../../../components/Input-Mobile/InputAndLabelMobile";
import Spinner from "../../../../components/Spinner";
import useAuthData from "../../../../hook/useAppData";
import { IconPencil, IconPencilRevert, IconRightArrow } from "../../../../icons";
import { convertDate } from "../../../../libs/dateUtils";
import { service } from "../../../Project/service/service";
import { Points, TimeSheetProps } from "../../model";
import { getPointsByDay } from "../../service";
import { TitleMobile } from "../components/TitleMobile";
import { HistoryEditMobile } from "./HistoryEditMobile";

export type TypeEditPage = "details" | "edit";

export function HistoryDetailsMobile({ setPages, dateRow }) {
  const { token, userId } = useAuthData();

  const [pointsOfDay, setPointsOfDay] = useState<Points[]>();
  const [listProject, setListProject] = useState<{ id: number; name: string }[]>();
  const [needSpinner, setNeedSpinner] = useState(false);
  const [editPage, setEditPage] = useState<TypeEditPage>("details");
  const [pointsEdit, setPointsEdit] = useState<Points>();
  const [info, setInfo] = useState<{ index: number; pointsOfDay: Points[] }>();

  useEffect(() => {
    getAllPoints();
    getAllProjects();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }, [pointsOfDay, listProject]);

  async function getAllPoints() {
    const datePoints: TimeSheetProps = await getPointsByDay(token, userId, dateRow);
    setPointsOfDay(datePoints?.points);
  }

  async function getAllProjects() {
    const projectName: { id: number; name: string }[] = await service.getProjects(token);
    setListProject(projectName);
  }

  return (
    <>
      {editPage === "details" && (
        <div className="h-full">
          <TitleMobile title={"Histórico de " + convertDate(dateRow)} onClick={() => setPages("history")} />
          {!needSpinner && (
            <div className="flex flex-row items-center card-points h-4/5">
              {pointsOfDay?.map((point, index) => {
                const name = listProject?.find((project) => project?.id === point?.projectId)?.name;
                const nameWithLimitOfLength = name?.length > 27 ? name?.slice(0, 27) + "..." : name;
                return (
                  <div className="flex h-full flex-col justify-center items-center bg-primary p-5 w-screen">
                    <div className="card flex flex-col bg-white pt-10 rounded-xl h-4/5">
                      <p>
                        <h2 className="text-white text-6xl bg-primary flex justify-center items-start rounded-2xl p-4 mx-20">Projeto</h2>
                        <span className="inline-flex text-center font-familyPoppins text-4xl text-textPrimary justify-center p-2 mt-5 mb-20">
                          {nameWithLimitOfLength}
                        </span>
                      </p>
                      <div className="flex flex-col justify-center mx-10 mt-32 gap-10 text-black text-4xl">
                        <div className="border-2 p-5 rounded-2xl border-gray-700 flex justify-between">
                          <span>Entrada</span>
                          <span>{point?.entrance}</span>
                        </div>
                        <div className="border-2 p-5 rounded-2xl border-gray-700 flex justify-between">
                          <span>Saída</span>
                          <span>{point?.exit}</span>
                        </div>
                      </div>
                    </div>
                    <span className="flex justify-center -mt-10 items-end content-end">
                      <IconButton
                        icon={IconPencilRevert}
                        className="flex content-end justify-center rounded-full bg-white border border-gray-800 shadow-4xl w-20 h-20 text-black"
                        onClick={() => {
                          setInfo({ index, pointsOfDay });
                          setEditPage("edit");
                          setPointsEdit(point);
                        }}
                      />
                    </span>
                  </div>
                );
              })}
            </div>
          )}
          <div className="flex flex-row items-center justify-center card-poits">
            {needSpinner && <Spinner status={needSpinner} className="h-full w-full spinner-mobile-homepage-timesheet"></Spinner>}
          </div>
        </div>
      )}{" "}
      {editPage === "edit" && (
        <HistoryEditMobile
          dateRow={dateRow}
          setEditPage={setEditPage}
          pointsEdit={pointsEdit}
          setPointsEdit={setPointsEdit}
          listProject={listProject}
          info={info}
          setInfo={setInfo}
          getAllPoints={getAllPoints}
        />
      )}
    </>
  );
}
